import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import { 
  createComponentConfig, 
  createComponentItem,
  COMPONENT_TYPES,
  PROMPT_STRATEGIES,
  TOOL_IDS
} from '../../AiToolTemplate/config/componentConfig';

const PopArtPortrait = () => {
  const { t } = useI18n();

  // 创建PopArtPortrait的配置
  const popArtConfig = createComponentConfig({
    components: [
      createComponentItem({
        type: COMPONENT_TYPES.IMAGE_UPLOAD,
        id: 'sourceImage',
        title: t('aiToolTemplate.uploadImage'),
        description: t('aiToolTemplate.uploadImageDescription'),
        required: true,
        props: {
          acceptedFormats: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
          maxSize: 10 * 1024 * 1024, // 10MB
          preview: true,
          cropAspectRatio: null,
          placeholder: t('aiToolTemplate.clickOrDragUpload')
        }
      }),
      createComponentItem({
        id: 'size',
        type: COMPONENT_TYPES.SIZE_SELECTOR,
        title: t('aiWorkbench.aspectRatio'),
        required: true,
        defaultValue: 'Auto'
      }),
      createComponentItem({
        type: COMPONENT_TYPES.PROMPT_INPUT,
        id: 'supplementaryPrompt',
        title: t('aiToolTemplate.supplementaryPrompt'),
        description: t('aiToolTemplate.supplementaryPromptDescription'),
        required: false,
        props: {
          placeholder: t('aiToolTemplate.enterSupplementaryPrompt')
        }
      })
    ],
    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.supplementaryPrompt;
      }
    },
    additionalParams: {
      model: 'nano',
      width: 1024,
      height: 1024,
      style: 'pop-art'
    }
  });

  return (
    <AiToolTemplateV2
      toolName={t('aiToolTemplate.tools.popArt.name')}
      toolIcon="🎨"
      toolDescription={t('aiToolTemplate.tools.popArt.description')}
      config={popArtConfig}
      gradientColors={['#ff6b6b', '#feca57']}
      toolId={TOOL_IDS.POP_ART_PORTRAIT}
    />
  );
};

export default PopArtPortrait;
